import {
  Component,
  inject,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { decodeBase64ToText, encodeToBase64 } from '../utility';
import { Outcome } from './outcome.service';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import { HttpService } from '../shared/services/http.service';
import { environment } from '../../environments/environment';
import { SidebarService } from '../shared/services/sidebar.service';
import { HelperService } from '../shared/services/helper.service';
import { ToastService } from '../shared/services/toast.service';
import { PageMetadataService } from '../shared/services/page-metadata.service';

@Component({
  selector: 'app-outcome',
  templateUrl: './outcome.component.html',
  styleUrl: './outcome.component.css',
})
export class OutcomeComponent implements OnInit {
  // @ViewChild('scrollPanel') scrollPanel: ScrollPanel | undefined;
  // @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  cloneModal: boolean = false;
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;

  quarterlyOutcomes = [
    {
      quarter: 'Quarter 1, 2024',
      outcome: 'Develop a New Product Vision',
      milestones: 5,
      isChecked: true,
    },
    {
      quarter: 'Quarter 1, 2024',
      outcome: 'Launch new tool successfully',
      milestones: 4,
      isChecked: false,
    },
    {
      quarter: 'Quarter 1, 2024',
      outcome: 'Launch new tool asia wide',
      milestones: 3,
      isChecked: false,
    },
    {
      quarter: 'Quarter 2, 2024',
      outcome: 'Develop a New Product Vision',
      milestones: 7,
      isChecked: false,
    },
  ];

  outcomes: any[] = [];
  outcomeOne: any[] = [];
  page: number = 0;
  prevPage: number = 0;
  limit = 20;
  loading = false;
  isLoading: boolean = false;
  private outCome = inject(Outcome);
  private toastService = inject(ToastService);
  public sidebarService = inject(SidebarService);
  private httpService = inject(HttpService);
  private helper = inject(HelperService);
  private roleSubscription: Subscription;
  private apiService = inject(ApiService);
  private pageMetaData = inject(PageMetadataService);

  isSidebarOpen: boolean = false;
  outcomesParams: any = {};
  outcomesData: any = [];
  detailOutcomeData: any;
  filterCount: number;
  businessThemeLists: any = [];

  cat: any = '';
  cloneData: any = [];
  outcomeIds: any = [];
  outcomeUrl: string;
  selectOutcomeSubGroupsData: any = [];
  outcomeListParentGroup: any[];
  outcomeTeamMembers: any = [];
  isCloningSTO: boolean = false;
  outcomePayload: any;
  ngOnInit(): void {
    this.sidebarService.cleanOutcomesSelection();
    this.pageMetaData.setTitle('Outcomes | OBP');
    this.breadCrumbItems = [{ label: 'Outcomes' }];
    this.helper.isOutcomeDataLoad$.subscribe((res: any) => {
      if (res) {
        this.loadOutcomesList({ ...this.sidebarService?.outcomeData });
      }
    });
    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      // this.loadOutcomesList({}, data);
      this.initialLoad(data);
      // this.loadOutcomes(data);
    });
    // this.helper.fetchThemeList(new Date().getFullYear());

    this.outcomeUrl = `${environment.opbBackendHost}/api/${this.cat}/outcomes/list`;
  }

  initialLoad(data: any) {
    this.isLoadingOutcomes = true;
    this.cat = data;
    this.helper
      .fetchParentStandaloneGroupList(data, 'page') // send by parent Id
      .subscribe((responseParent: any) => {
        this.outcomeListParentGroup = responseParent?.data || responseParent;
        this.helper
          .fetchParentStandaloneGroupList(data, '') // without parent ID
          .subscribe((res: any) => {
            const merged = [...this.outcomeListParentGroup, ...res.data];
            const mergedGroups = Array.from(
              new Map(merged.map((group) => [group.group_id, group])).values()
            );
            this.outcomeListParentGroup = mergedGroups;
            this.sidebarService.selectedOutcomeGroup =
              this.outcomeListParentGroup[0];
          });

        this.helper
          .getSubgroupListData(
            this.cat,
            this.outcomeListParentGroup[0]?.group_id,
            true
          )
          .subscribe((response: any) => {
            this.helper
              .getSubgroupListData(
                this.cat,
                this.outcomeListParentGroup[0]?.group_id,
                false
              )
              .subscribe((responseWithoutMemberID: any) => {
                let merged = [
                  this.selectOutcomeSubGroupsData,
                  ...responseWithoutMemberID.data,
                ];
                const mergedGroups = Array.from(
                  new Map(
                    merged?.map((group) => [group?.group_id, group])
                  ).values()
                ).filter((group) =>
                  Object.values(group).some(
                    (value) =>
                      value !== null && value !== '' && value !== undefined
                  )
                );

                this.selectOutcomeSubGroupsData = mergedGroups;
              });

            this.sidebarService.selectedOutcomeSubgroup = response?.data[0];
            this.helper
              .fetchMembersList(this.cat, {
                groups:
                  this.sidebarService.selectedOutcomeSubgroup?.group_id ||
                  this.outcomeListParentGroup[0]?.group_id,
              })
              ?.subscribe((resp: any) => {
                this.helper
                  .fetchMembersList(this.cat, {
                    include_members: this.helper.loggedInUser?.user_id,
                  })
                  .subscribe((loggedUser: any) => {
                    this.outcomeTeamMembers = [
                      ...this.outcomeTeamMembers,
                      ...loggedUser.data,
                      ...resp?.data,
                    ];
                    // this.outcomeTeamMembers = resp?.data;
                    const uniqueMember = Array.from(
                      new Map(
                        this.outcomeTeamMembers.map((member: any) => [
                          member.user_id,
                          member,
                        ])
                      ).values()
                    );

                    this.outcomeTeamMembers = uniqueMember;
                    this.sidebarService.selectedOutcomeMembers =
                      this.outcomeTeamMembers?.find(
                        (m: any) =>
                          m.user_id === this.helper.loggedInUser.user_id
                      );
                    this.sidebarService.outcomeData.group_members =
                      this.sidebarService.selectedOutcomeMembers?.user_id;
                  });

                const loggedInUserId = this.helper.loggedInUser.user_id;
                const selectedGroupId =
                  this.sidebarService.selectedOutcomeSubgroup?.group_id ||
                  this.outcomeListParentGroup[0]?.group_id;
                const currentYear = new Date().getFullYear();
                // const parentGroupId = response?.data[0]?.group_id;

                this.sidebarService.outcomeData = {
                  ...this.sidebarService.outcomeData,
                  // parent_group: parentGroupId || '',
                  outcome_groups: selectedGroupId,
                  outcome_year: currentYear,
                };

                this.onDropdownSelection({
                  ...this.sidebarService.outcomeData,
                  group_members: loggedInUserId,
                });
              });
          });
      });
  }

  onOutcomeTeamberSearch(data: any) {
    if (Array.isArray(data)) {
      const combined = [...this.outcomeTeamMembers, ...data];
      this.outcomeTeamMembers = Array.from(
        new Map(combined.map((member) => [member.user_id, member])).values()
      );
    } else if (data && typeof data === 'object' && 'user_id' in data) {
      const index = this.outcomeTeamMembers.findIndex(
        (member: any) => member.user_id === data.user_id
      );

      if (index !== -1) {
        this.outcomeTeamMembers[index] = data;
      } else {
        this.outcomeTeamMembers.push(data);
      }
    }
  }

  onelectOutcomeSubGroupsData(data: any) {
    this.selectOutcomeSubGroupsData = data;
  }

  getSublist() {}

  outcomeDetailData(data: any) {
    this.detailOutcomeData = data;
  }
  constructor() {}
  onDataLoaded(data: any) {
    this.outcomes = data;
  }
  isLoadingOutcomes: boolean = false;
  isLoadingShimmer: boolean = false;

  loadOutcomesList(data?: any, cat: any = this.cat) {
    this.outcomePayload = {
      ...data,
      search: this.searchText || '',
    };
    if (cat !== '') {
      this.isLoadingOutcomes = true;

      this.httpService
        .post(`${environment.opbBackendHost}/api/${cat}/outcomes/list`, {
          page: 1,
          ...data,
        })
        .subscribe({
          next: (res: any) => {
            this.outcomes = res.data;
            this.isLoadingOutcomes = false;
          },
          error: (err: any) => {
            console.error('Error fetching outcomes:', err);
            this.isLoadingOutcomes = false;
          },
        });
    }
  }

  searchText: string = '';

  onSearchChange(value: string): void {
    this.sidebarService.outcomeData.search = value;
    // this.outcomesParams = {
    //   search: value,
    //   ...this.sidebarService?.outcomeData,
    // };
    this.loadOutcomesList(this.sidebarService.outcomeData);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  onDropdownSelection(filterData: any) {
    this.searchText = '';
    this.outcomesParams = filterData;
    //     if(this.cat =='affiliate'){
    //       this.sidebarService.selectedOutcomeGroup=null
    //       this.sidebarService.selectedOutcomeMembers=null
    //       this.sidebarService.selectedOutcomeSubgroup=null
    //       this.outcomesParams.outcome_groups= '',
    //       this.outcomesParams.group_members= ''
    // }
    this.filterCount = this.getFilledPropertiesCount(filterData);
    this.loadOutcomesList(filterData);
  }

  handleChildEvent(event: any) {
    this.loadOutcomesList(this.outcomesParams);
  }

  getFilledPropertiesCount(data: any) {
    return Object.keys(data).filter(
      (key) =>
        data[key] !== null &&
        data[key] !== undefined &&
        data[key] !== '' &&
        data[key] !== ''
    ).length;
  }

  fetchThemeList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/themes`, {
        year: new Date().getFullYear(),
      })
      .subscribe((res: any) => {
        this.businessThemeLists = res?.data;
      });
  }

  loadOutcomes(cat: any): void {
    if (this.loading) return;
    this.loading = true;

    const data = {
      outcome_themes: '',
      outcome_groups: '',
      group_members: '',
      untouched_outcome: 'no',
      outcome_status: '1,2,3,4,5',
      page: this.page,
    };
    this.outCome.getoutcomes(data, cat).subscribe((res) => {
      const parsedData = res;

      this.outcomes = [...this.outcomes, ...parsedData.data];
      if (parsedData.data.length < 10) {
        this.prevPage++;
      } else {
        this.page++;
        this.prevPage++;
      }
      this.loading = false;
      this.isLoading = false;
    });
  }

  // ngAfterViewInit(): void {
  //   // Listen to the native scroll event using the ViewChild reference
  //   this.scrollContainer.nativeElement.addEventListener(
  //     'scroll',
  //     (event: any) => {
  //       this.onScroll(event); // Use an arrow function to preserve the correct context (`this`)
  //     }
  //   );
  // }

  detailOutcome(cat: any, outcomeId: string) {
    const data = {
      outcome_id: outcomeId,
    };
    this.outCome.detailOutcome(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.outcomeOne = parsedData.data;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  selectedRows: any[] = [];
  updateSelectedRow(row: any) {
    if (row.isChecked) {
      this.selectedRows.push(row);
    } else {
      this.selectedRows = this.selectedRows.filter(
        (selected) => selected !== row
      );
    }
  }

  clickDetailOutcome(outcomeId: any) {
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.detailOutcome(data, outcomeId);
    });
  }

  // onScroll(event: any): void {
  //   if (this.prevPage === this.page) {
  //     this.roleSubscription = this.apiService.role$.subscribe((data) => {
  //       this.loadOutcomes(data);
  //     });
  //   }
  // }

  // onScroll(event: any): void {
  //   const scrollPanel = event.target; // Get the scrollable element

  //   const bottom = scrollPanel.scrollHeight === scrollPanel.scrollTop + scrollPanel.clientHeight;
  //   if (bottom && !this.loading) {
  //     this.roleSubscription = this.apiService.role$.subscribe((data) => {
  //       this.loadOutcomes(data);
  //     });
  //   }

  // }

  cloneQuarterlyOutcomes() {
    this.fetchActiveTImeLine();
  }

  fetchActiveTImeLine() {
    this.isCloningSTO = true;
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/${this.cat}/current/timeline`,
        {}
      )
      .subscribe((res: any) => {
        if (!res.data) {
          this.toastService.error(
            'No data found to clone as there is no active timeline'
          );
        } else {
          this.getCloneQuarterlyOutcomesData();
          this.cloneModal = true;
        }
        this.isCloningSTO = false;
      });
  }

  getCloneQuarterlyOutcomesData() {
    this.isLoadingShimmer = true;
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/${this.cat}/quarterly/outcomes`,
        {}
      )
      .subscribe((res: any) => {
        this.cloneData = res?.data || [];
        this.cloneData = this.cloneData?.map((item: any) => ({
          ...item,
          isChecked: false,
          isQuarterSelected: false,
        }));
        this.isLoadingShimmer = false;
      });
  }

  cloneQuarterlyOutcome(outcomeData: any) {
    let outcomeIds = outcomeData?.join(',');
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/${this.cat}/quarterly/outcomes/clone`,
        { outcome_ids: outcomeIds }
      )
      .subscribe((response: any) => {
        this.cloneData = response.data;
        response?.error
          ? this.toastService.error(response?.message)
          : this.toastService.success(response?.message);
        this.isLoadingOutcomes = false;
        this.closeCloneModal();
      });
  }

  closeCloneModal() {
    this.cloneModal = false;
  }

  shouldDisplayRowspan(rowIndex: number): boolean {
    return (
      rowIndex === 0 ||
      this.cloneData[rowIndex]?.quarter != this.cloneData[rowIndex - 1]?.quarter
    );
  }

  calculateRowspan(quarter: string): number {
    return this.cloneData.filter((row: any) => row.quarter == quarter).length;
  }

  // Logic to toggle quarter selection
  toggleQuarterSelection(quarter: string, isQuarterSelected: boolean): void {
    this.cloneData.forEach((row: any) => {
      if (row.quarter == quarter) {
        row.isChecked = isQuarterSelected;
      }
    });
    this.outcomeIds = this.cloneData
      ?.filter((m: any) => m.isChecked)
      ?.map((m: any) => m.outcome_id);
  }

  // Logic to toggle individual outcome selection
  toggleOutcomeSelection(quarter: string): void {
    let outcomesForQuarter = this.cloneData.filter(
      (row: any) => row.quarter == quarter
    );

    let checkInner = outcomesForQuarter.every((row: any) => row.isChecked);
    outcomesForQuarter.forEach((row: any) => {
      row.isQuarterSelected = checkInner;
    });
    this.outcomeIds = this.cloneData
      ?.filter((m: any) => m.isChecked)
      ?.map((m: any) => m.outcome_id);
  }

  ngOnDestroy(): void {
    this.sidebarService.cleanOutcomesSelection();
    //   // Remove the event listener when the component is destroyed to avoid memory leaks
    //   this.scrollContainer.nativeElement.removeEventListener(
    //     'scroll',
    //     this.onScroll
    //   );
    //   if (this.roleSubscription) {
    //     this.roleSubscription.unsubscribe(); // Clean up subscription when component is destroyed
    //   }
  }
}
